export interface PageTemplateInputDto {
    title: string;
    slug: string;
    description: string;
}
